import { PROJECT_DROPDOWN_LIST, SITE_SCRIPT_TEMPLATE, SITE_GENERATE_BUSINESS_LOGIC_STEPS, SITE_TEST_CREDENTIALS_CHECK_AUTH, SITE_CHECK_SESSION_REFRESH, SITE_UPLOAD_IMPORT_FILE, UPDATE_OTP_REQUEST_STATUS, SAVE_SCAN_REQUESTED_OTP } from "../constants/api-path";
import httpClient from "./http.interceptor";

/**
 * 
 * @returns Promise<any>
 */
export const siteProjectListAPI = (): Promise<any> => {
    return httpClient.get(PROJECT_DROPDOWN_LIST);
};

/**
 * 
 * @param file 
 * @returns Promise<any>
 */
export const siteUploadFileAPI = (file: any): Promise<any> => {
    return httpClient.post(SITE_UPLOAD_IMPORT_FILE, file);
}

export const testCredentialsAPI = (payload: any): Promise<any> => {
    return httpClient.post(SITE_TEST_CREDENTIALS_CHECK_AUTH, payload);
}

export const testSessionRefreshAPI = (payload: any): Promise<any> => {
    return httpClient.post(SITE_CHECK_SESSION_REFRESH, payload);
}


export const getScriptAPI = (payload: any): Promise<any> => {
    return httpClient.post(SITE_SCRIPT_TEMPLATE, payload);
}

export const generateBusinessLogicStepsAPI = (payload: any): Promise<any> => {
    return httpClient.post(SITE_GENERATE_BUSINESS_LOGIC_STEPS, payload);
}

export const updateOtpRequestStatus = (payload: any): Promise<any> => {
    return httpClient.put(UPDATE_OTP_REQUEST_STATUS, payload);
}

export const saveRequestedOTP = (payload: any): Promise<any> => {
    return httpClient.put(SAVE_SCAN_REQUESTED_OTP, payload);
}